<div class="m-fade-in-up">
  <ng-content></ng-content>
</div>
